<div class="flex md:px-6 pl-9 py-3 space-x-3 items-center">
	<span class="flex-auto font-semibold text-3xl">{{ title }}</span>
	<ng-container *ngIf="!(appController.isConnected$ | async)">
		<p-menu
			#menu
			[model]="appController.languageOptions$ | async"
			[popup]="true"
		></p-menu>
		<button
			[bdcWalkTriggerFor]="activityLanguageWalkthrough"
			[pTooltip]="'presentation.app.toolbar.menu.language' | translate"
			(click)="menu.toggle($event)"
			class="p-button-shadowed"
			icon="spreeng spreeng-globe"
			pButton
			tooltipPosition="left"
		></button>
		<bdc-walk-popup
			#activityLanguageWalkthrough
			[buttonText]="'presentation.common.bdcWalkthrough.next' | translate"
			[header]="i18n + '.languageWalkthrough.header' | translate"
			[showButton]="true"
			[showCloseButton]="false"
			name="activityLanguageWalkthrough"
			xPosition="before"
			yPosition="below"
		>
			<span class="whitespace-pre-line">
				{{ i18n + '.languageWalkthrough.text' | translate }}
			</span>
		</bdc-walk-popup>
	</ng-container>
	<ng-content select="[actions]"></ng-content>
</div>
<div [class]="styleClass" class="flex-auto relative h-full">
	<ng-content></ng-content>
</div>
